import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { setItem } from "../../common/localStorage";

const FormInfo = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const charLimit = 120;
  const navigate = useNavigate();

  const { state } = useLocation();
  const { t } = useTranslation();

  const navigateToFormstart = () => {
    setItem("formDetails",state)
    navigate("/form", { state: state });
  };

  const totalQuestions = state?.item?.formData?.length || 0;
  const attemptedQuestions = state?.item?.formData?.filter(
    (question) => question?.userAnswer?.trim() !== ""
  ).length;

  // Calculate progress
  const progressPercentage =
    totalQuestions > 0 ? (attemptedQuestions / totalQuestions) * 100 : 0;

  return (
    <>
     
      <div className="py-50 mobileMargin">
        <div className="container">
          <div className="doctorGrid">
            <div className="doctorCard">
              <div>
                <div className="progressBar mb-8">
                  <div
                    className="progress"
                    style={{
                      width: `${progressPercentage}%`,
                    }}
                  ></div>
                </div>
              </div>

              <div className="fs-20 tgb mb-10">{state?.item?.formTitle||"N/A"}</div>
              <div className="l15 mb-20">
                {isExpanded
                  ? state?.item?.formDescription
                  : state?.item?.formDescription?.length > charLimit
                  ? `${state?.item?.formDescription.substring(0, charLimit)}...`
                  : state?.item?.formDescription}
              </div>

              {state?.item?.formDescription?.length > charLimit && (
                <div
                  className="show-more-less-clickable mb-20"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? t("View less") : t("View more")}
                </div>
              )}

              <button
                className="startBtn cursor-pointer"
                onClick={navigateToFormstart}
              >
                {t("Start")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormInfo;
